import type { Media, MediaKind } from '@prisma/client'
import type { Dispatch, SetStateAction } from 'react'
import { createContext } from 'react'

import type { AmendableAttachment } from '~/schemas/attachment'

export type AmendableAttachmentType = Omit<AmendableAttachment, 'mediaId'> & {
  media: Media
  id?: string
  targetId?: string
  targetIdByKey?: string
  targetType?: string
}

export type MediaManagerContextIntentType =
  // the media manager component is responsible for submitting the attachments
  | 'upload_attachments'
  // the meida manager component should return the attachments with the help of onAttachmentsChange,
  // so the component that is using it does what it wants with the attachements
  | 'return_attachments'

export type MediaManagerContextData = {
  isOpen: boolean
  intent: MediaManagerContextIntentType
  maxSelected?: number
  title?: string
  targetType?: string
  targetIdByKey?: string
  targetId?: string | null
  attachments?: AmendableAttachmentType[]
  allowedMediaKinds?: MediaKind[]
  onAttachmentsChange?: (attachments: AmendableAttachmentType[]) => void
  onAttachmentsComplete?: (attachments: AmendableAttachmentType[]) => void
}

export type MediaManagerContextType = [
  MediaManagerContextData,
  Dispatch<SetStateAction<MediaManagerContextData>>,
]

export const MediaManagerContext = createContext<MediaManagerContextType>([
  {
    isOpen: false,
    intent: 'upload_attachments',
  },
  () => {
    // noop
  },
])
